



















































import { Component, Vue } from "vue-property-decorator";
import { withDrawColumnList } from "./config";
import { extractDataAnalysisEnd } from "@/req/dataIndex";
@Component({
  components: {},
})
export default class Home extends Vue {
  public baseList = {
    timeId: "",
    date_type: 1,
    start_time: "",
    end_time: "",
    page: 1,
    size: 10,
  };
  public timeList: any = [];
  public loading = false;
  public columns = withDrawColumnList;
  public data: any = [];
  public parentList(list) {
    this.timeList = [];
    this.baseList.date_type = list.date_type;
    this.baseList.start_time = "";
    this.baseList.end_time = "";
    this.baseList.page = 1;
    this.baseList.size = 10;
    this.baseList.timeId = "";
    if (list.start_time && list.end_time) {
      this.timeList.push({
        value: this.timeList.length + 1,
        label: `${list.start_time} - ${list.end_time}`,
        start_time: list.start_time,
        end_time: list.end_time,
      });
    }
    if (list.contrast_start_time && list.contrast_end_time) {
      this.timeList.push({
        value: this.timeList.length + 1,
        label: `${list.contrast_start_time} - ${list.contrast_end_time}`,
        start_time: list.contrast_start_time,
        end_time: list.contrast_end_time,
      });
    }
    if (this.timeList.length >= 1) {
      this.baseList.timeId = this.timeList[0].value;
      this.baseList.start_time = this.timeList[0].start_time;
      this.baseList.end_time = this.timeList[0].end_time;
    }
    setTimeout(() => {
      this.getList();
    }, 0);
  }
  public setChange() {
    this.baseList.page = 1;
    if (this.baseList.timeId) {
      const arr = this.timeList.filter(
        (item) => item.value == this.baseList.timeId
      );
      this.baseList.start_time = arr[0].start_time;
      this.baseList.end_time = arr[0].end_time;
    }
    this.getList();
  }
  public change(index) {
    this.baseList.page = index;
    this.getList();
  }
  public sizeChange(size) {
    this.baseList.size = size;
    if (this.baseList.page == 1) {
      this.getList();
    }
  }
  public async getList() {
    this.loading = true;
    this.data = [];
    const { date_type, start_time, end_time, page, size } = this.baseList;
    const res = await extractDataAnalysisEnd({
      token: this.$fn.cookies.getToken(),
      date_type,
      start_time,
      end_time,
      export: 0,
      page,
      size,
    });
    if (res.code == 0) {
      this.data = res.data;
      this.data.current_page = Number(this.data.curr_page);
      this.loading = false;
    }
  }
  public exportExcel() {
    const { date_type, start_time, end_time } = this.baseList;
    const baseList: any = {
      token: this.$fn.cookies.getToken(),
      date_type,
      start_time,
      end_time,
      export: 1,
    };
    const windowUrl = this.$fn.exportExcelUrl(
      baseList,
      this.$HTTP_API.dataIndex.extractDataAnalysisEnd
    );
    window.open(windowUrl);
  }
}
